import React from 'react';

export const Hero = () => (
  <div className="relative w-full">
    <picture className="absolute inset-0 w-full h-full block">
      <img
        src="/img/adviser/resources/academy/marketing-guides/hero.webp"
        alt="CPD events background"
        fetchPriority="high"
        className="w-full h-full object-cover object-center"
      />
    </picture>
    <div className="absolute inset-0 w-full h-full bg-[#101733]/90 z-10"/>

    <div className="container mx-auto md:text-center relative z-10 flex flex-col items-center justify-center py-16 lg:py-20">
      <h1 className="text-[#007DD1] font-semibold text-xl text-center mb-4">CPD events</h1>

      <h2 className="text-[#F3F4F8] text-4xl md:text-5xl font-semibold text-center mb-6 lg:w-[50rem]">
        Boost Your CPD Hours With Our Educational Events
      </h2>

      <p className="text-[#F3F4F8] font-normal text-base text-center lg:w-[48rem]">
        Join us for our CPD-accredited events, designed to address topics relevant to you and your clients.
        Discover our upcoming events below, and secure your spot today.
      </p>
    </div>
  </div>
);
